export var container = 'c5-27-4_nly6ul0 c5-27-4_nly6ul2s c5-27-4_nly6ul30';
export var leftContent = 'c5-27-4_161xunp20 c5-27-4_161xunp3w c5-27-4_161xunp5s c5-27-4_161xunp7o c5-27-4_nly6ul0 c5-27-4_161xunpks';
export var linkButtonContainer = 'c5-27-4_nly6ul3t';